'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.redirectLoggedInUserToWorkspace = exports.updateBoardSlug = exports.navigateToRootWorkspace = exports.clearFilter = exports.navigateToBoard = exports.navigateToStaticPage = exports.navigateToForgotPassword = exports.navigateToRegister = exports.navigateToLogin = exports.refreshPage = undefined;

var _reactRouterRedux = require('react-router-redux');

var _lodash = require('lodash');

var _stringUtil = require('../../common/utils/stringUtil');

var _selectionActions = require('../element/selection/selectionActions');

var _currentUserActions = require('../user/currentUserActions');

var _currentUserSelector = require('../user/currentUserSelector');

var getLocation = function getLocation(state) {
    return (0, _lodash.get)(state.get('routing'), 'locationBeforeTransitions', {});
};
var getLocationSearch = function getLocationSearch(state) {
    return getLocation(state).search || '';
};
var getLocationPathname = function getLocationPathname(state) {
    return getLocation(state).pathname || '';
};
var getLocationQuery = function getLocationQuery(state) {
    return getLocation(state).query || {};
};

var refreshPage = exports.refreshPage = function refreshPage() {
    return window.location.reload(false);
};

var navigateToLogin = exports.navigateToLogin = function navigateToLogin() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        from = _ref.from;

    var loginPath = from ? '/login?from=' + from : '/login';

    return (0, _reactRouterRedux.push)(loginPath);
};

var navigateToRegister = exports.navigateToRegister = function navigateToRegister() {
    return (0, _reactRouterRedux.push)('/register');
};
var navigateToForgotPassword = exports.navigateToForgotPassword = function navigateToForgotPassword() {
    return (0, _reactRouterRedux.push)('/forgotten-password');
};
var navigateToStaticPage = exports.navigateToStaticPage = function navigateToStaticPage(pageName) {
    return (0, _reactRouterRedux.push)('/static/' + pageName);
};

/**
 * Updates the route to the new board's location.
 */
var navigateToBoard = exports.navigateToBoard = function navigateToBoard(_ref2) {
    var boardId = _ref2.boardId,
        filter = _ref2.filter,
        _ref2$keepSelection = _ref2.keepSelection,
        keepSelection = _ref2$keepSelection === undefined ? false : _ref2$keepSelection;
    return function (dispatch, getState) {
        if (!boardId) return dispatch((0, _reactRouterRedux.push)('/'));

        var state = getState();
        var board = state.getIn(['elements', boardId]);

        var title = board && board.getIn(['content', 'title']);

        var slug = title ? '/' + (0, _stringUtil.slugify)(title) : '';
        var filters = filter ? '?' + (0, _stringUtil.createQueryString)(filter) : '';
        var path = '/' + boardId + slug + filters;

        if (!keepSelection) dispatch((0, _selectionActions.deselectAllElements)());

        return dispatch((0, _reactRouterRedux.push)(path));
    };
};

var clearFilter = exports.clearFilter = function clearFilter() {
    return function (dispatch, getState) {
        var state = getState();
        var filterState = getLocationSearch(state);
        if (!filterState) return;

        var pathname = getLocationPathname(state);
        return dispatch((0, _reactRouterRedux.push)(pathname));
    };
};

var navigateToRootWorkspace = exports.navigateToRootWorkspace = function navigateToRootWorkspace() {
    return function (dispatch, getState) {
        var state = getState();

        var redirectFrom = getLocationQuery(state).from;
        if (redirectFrom) return dispatch((0, _reactRouterRedux.push)(redirectFrom));

        var rootBoardId = (0, _currentUserSelector.getCurrentUserRootBoardId)(state);
        if (rootBoardId) return dispatch(navigateToBoard({ boardId: rootBoardId }));

        dispatch((0, _reactRouterRedux.push)('/'));
    };
};

var updateBoardSlug = exports.updateBoardSlug = function updateBoardSlug(_ref3) {
    var boardId = _ref3.boardId,
        routeParams = _ref3.routeParams;
    return function (dispatch, getState) {
        var state = getState();
        var board = state.get('elements').get(boardId);

        var title = board && board.get('content') && board.get('content').get('title');
        var slug = title ? (0, _stringUtil.slugify)(title) : null;
        var urlQuery = getLocationSearch(state);

        if (!slug || routeParams.slug === slug) return;

        var path = '/' + boardId;
        path = slug ? path + '/' + slug + urlQuery : path;

        return dispatch((0, _reactRouterRedux.replace)(path));
    };
};

// redirects to root workspace, but keeps a flag if the user has been redirected
// from login to avoid redirect loops with mangled auth tokens
var redirectLoggedInUserToWorkspace = exports.redirectLoggedInUserToWorkspace = function redirectLoggedInUserToWorkspace() {
    return function (dispatch, getState) {
        var state = getState();
        if (state.getIn(['app', 'currentUser', 'didRedirect'])) return;

        dispatch((0, _currentUserActions.updateCurrentUser)({
            changes: { didRedirect: true },
            sync: false
        }));

        dispatch(navigateToRootWorkspace());
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/reducers/navigationActions.js
// module id = 27
// module chunks = 0